import React, { useContext, useState } from 'react';
import { OrdersSadanContext } from "../OrdersSadanContext";
import _axios from "../../../httpService";
import { prefixUrl } from "../../../utils/utilsData";

const DiscountCode = () => {
  const helper = useContext(OrdersSadanContext);
  const data = helper.data;
  const setData = helper.setData;

  const [codeStatus, setCodeStatus] = useState(null); // null | 'valid' | 'invalid'
  const [codeMessage, setCodeMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const calculateSubtotal = () => {
    const tableData = data?.tableData || [];
    return tableData.reduce((sum, row) => {
      const price = parseFloat(row.price) || 0;
      const number = parseFloat(row.number) || 0;
      return sum + (price * number);
    }, 0);
  };

  const applyDiscountCode = async () => {
    const code = data?.discountCode?.trim();
    if (!code) {
      setCodeStatus('invalid');
      setCodeMessage('کد تخفیف را وارد کنید');
      return;
    }
    setLoading(true);
    try {
      const res = await _axios.get(
        prefixUrl() + `/groceryStoreSellFactor/?request=validateDiscountCode&code=${code}`
      );
      const result = res.data;
      if (result.status) {
        const { type, mbtakhfif, darsadtakhfif, mbmax } = result.data;
        let discountAmount = 0;
        if (type === 'ریالی') {
          discountAmount = mbtakhfif;
        } else {
          const subtotal = calculateSubtotal();
          const raw = subtotal * (darsadtakhfif / 100);
          discountAmount = Math.min(raw, mbmax);
        }
        setData({ ...data, discountPrice: String(Math.round(discountAmount)) });
        setCodeStatus('valid');
        setCodeMessage('کد تخفیف اعمال شد ✅');
      } else {
        setData({ ...data, discountPrice: '0' });
        setCodeStatus('invalid');
        setCodeMessage(result.message);
      }
    } catch (e) {
      setData({ ...data, discountPrice: '0' });
      setCodeStatus('invalid');
      setCodeMessage('خطا در بررسی کد تخفیف');
    }
    setLoading(false);
  };

  const handleBlur = () => {
    if (data?.discountCode?.trim()) {
      applyDiscountCode();
    }
  };

  const handleCodeChange = (e) => {
    setCodeStatus(null);
    setCodeMessage('');
    setData({ ...data, discountCode: e.target.value, discountPrice: '0' });
  };

  return (
    <div className="mx-2 grid-row">
      <div className={"div__group__input_select"}>
        <label htmlFor={"discountCode"}>کد تخفیف</label>
        <div style={{ display: 'flex', gap: '6px' }}>
          <input
            type="text"
            id="discountCode"
            name="discountCode"
            value={data?.discountCode || ""}
            onChange={handleCodeChange}
            onBlur={handleBlur}
          />
          <button
            type="button"
            onClick={applyDiscountCode}
            disabled={loading}
            style={{ whiteSpace: 'nowrap' }}
          >
            {loading ? '...' : 'اعمال'}
          </button>
        </div>
        {codeMessage && (
          <small style={{ color: codeStatus === 'valid' ? 'green' : 'red' }}>
            {codeMessage}
          </small>
        )}
      </div>
      <div className={"div__group__input_select"}>
        <label htmlFor={"discountPrice"}>مبلغ تخفیف</label>
        <input
          type="text"
          id="discountPrice"
          name="discountPrice"
          value={data?.discountPrice || "0"}
          readOnly={codeStatus === 'valid'}
          onChange={e => {
            if (codeStatus !== 'valid') {
              setData({ ...data, discountPrice: e.target.value });
            }
          }}
          style={{ backgroundColor: codeStatus === 'valid' ? '#f0f0f0' : '' }}
        />
      </div>
    </div>
  );
};

export default DiscountCode;
